import { createActions } from 'redux-actions';

export const { loadAllCompanies, loadedAllCompanies, errorAllCompanies } = createActions(
  'LOAD_ALL_COMPANIES',
  'LOADED_ALL_COMPANIES',
  'ERROR_ALL_COMPANIES',
);

export const { companiesListRequest, moreCompaniesRequest, companiesListSuccess, companiesListFailure } = createActions(
  'COMPANIES_LIST_REQUEST',
  'MORE_COMPANIES_REQUEST',
  'COMPANIES_LIST_SUCCESS',
  'COMPANIES_LIST_FAILURE',
);

export const { flagWrongDataClicked, claimProfileClicked } = createActions(
  'FLAG_WRONG_DATA_CLICKED',
  'CLAIM_PROFILE_CLICKED',
);
